import React, { useState } from 'react'
import SbEditable from 'storyblok-react'
import MonthsFilter from './MonthsFilter'
import FourByTwoGridOnBrandItem from './FourByTwoGridOnBrandItem'

const FourByTwoGridOnBrandWithFilter = ({ blok }) => {

    const months = [ "All", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ]

    const [currentFilter, setCurrentFilter] = useState(months[0])

    return(
        <SbEditable content={blok} key={blok._uid}>
            <div className={`${blok.grey_bg ? "bg-midgrey py-16 lg:pt-24 sm:pt-20 sm:pb-24" : "bg-white my-16 lg:mt-24 sm:mt-20 sm:mb-24"}`}>
                <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8">
                    <MonthsFilter months={months} setCurrentFilter={setCurrentFilter} currentFilter={currentFilter}/>
                    <FourByTwoGridOnBrandItem  items={blok.items} months={months} currentFilter={currentFilter}/>
                </section>
            </div>
        </SbEditable>
    )
}

export default FourByTwoGridOnBrandWithFilter